import { FundingSourceType } from "@wingspanhq/payments/dist/interfaces";

/**
 * Funding source type for Stripe-backed cards. The payments service returns it for
 * payroll funding sources whose `fundingSourceId` is a Stripe paymentMethod (`pm_…`),
 * so that funds movements can route them over the Stripe rail instead of ACH/`Card`.
 *
 * It is declared here because the installed `@wingspanhq/payments` SDK (4.143.2) is
 * older than the service and doesn't include the enum member yet. Remove this constant
 * and use `FundingSourceType.StripePaymentCard` once the SDK is bumped.
 */
export const FUNDING_SOURCE_TYPE_STRIPE_PAYMENT_CARD =
  "StripePaymentCard" as FundingSourceType;
